import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OrganizationApiService } from './organization-api.service';

@Injectable({ providedIn: 'root' })
export class BrandLogoService {
  private readonly organizationApi = inject(OrganizationApiService);
  private readonly logoUrlSubject = new BehaviorSubject<string | null>(null);

  readonly logoUrl$: Observable<string | null> = this.logoUrlSubject.asObservable();

  /** Any failure (e.g. 403 without organization-view permission) just means "use the default logo". */
  refresh(): void {
    this.organizationApi.getOrganization().subscribe({
      next: (env) => this.set(env.data?.logo_url ?? null),
      error: () => this.set(null),
    });
  }

  set(url: string | null): void {
    this.logoUrlSubject.next(url);
  }
}
